import { render, staticRenderFns } from "./EventListTemplate.vue?vue&type=template&id=b892c9c0&scoped=true"
import script from "./EventListTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./EventListTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./EventListTemplate.vue?vue&type=style&index=0&id=b892c9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b892c9c0",
  null
  
)

export default component.exports